module.exports = __webpack_public_path__ + "static/media/share-calendar.7c70160a.svg";